var Link_types_LinkSize = /*#__PURE__*/ function(LinkSize) {
    LinkSize["large"] = "large";
    LinkSize["medium"] = "medium";
    LinkSize["small"] = "small";
    LinkSize["extraSmall"] = "extraSmall";
    return LinkSize;
}({});
var Link_types_LinkColor = /*#__PURE__*/ function(LinkColor) {
    LinkColor["primary"] = "primary";
    LinkColor["secondary"] = "secondary";
    LinkColor["tertiary"] = "tertiary";
    LinkColor["success"] = "success";
    LinkColor["error"] = "error";
    LinkColor["simple"] = "simple";
    return LinkColor;
}({});
export { Link_types_LinkColor as LinkColor, Link_types_LinkSize as LinkSize };
